<div class="pager" :class="{'pager--mobile': useMobile}">
    <div v-if="totalPages() > 0" class="pager__current">{{ $t('pager.page', { page: page, allpages: totalPages() }) }}</div>
    <div v-if="totalPages() <= 0" class="pager__not-found">{{ $t('pager.' + route.name) }}</div>
    <div class="pager__numbers" v-if="totalPages() > 0">
        <div class="pager__numbers-items">
            <div class="pager__numbers-item icon" :class="{ enabled: showPrevious() }" v-on:click="previous()">
                <i class="fa-solid fa-caret-left" />
            </div>
            <div class="pager__numbers-item" v-for="paged in pages" :class="{ 'active': page == paged }" v-on:click="setPage(paged)">{{ paged }}</div>
            <div class="pager__numbers-item icon" :class="{ enabled: showNext() }" v-on:click="next()">
                <i class="fa-solid fa-caret-right" />
            </div>
        </div>
    </div>
</div>